import CameraAltIcon from '@mui/icons-material/CameraAlt'
import CollectionsIcon from '@mui/icons-material/Collections'
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material'
import { FC } from 'react'

import { AddMediaButtonCached } from '../../../components/MediaGallery/AddMediaButtonCached'
import { MediaGalleryCached } from '../../../components/MediaGallery/MediaGalleryCached'
import { InspectionMediaEntry } from '../../../sdk'

interface Props {
  media: InspectionMediaEntry[]
  promptId: string
  open: boolean
  setOpen: (open: boolean) => void
  inspectionId: string
}

export const EntryMediaButtonCached: FC<Props> = ({
  media,
  promptId,
  open,
  setOpen,
  inspectionId
}) => {
  return (
    <>
      {media.length === 0 ? (
        <IconButton
          onClick={(event) => {
            event?.stopPropagation()
          }}
          color={'default'}
          component="label">
          <CameraAltIcon />
          <AddMediaButtonCached
            parentId={promptId}
            isMobileDevice
            inspectionId={inspectionId}
            curIndex={media.length}
          />
        </IconButton>
      ) : (
        <IconButton
          onClick={(event) => {
            event?.stopPropagation()
            setOpen(true)
          }}
          color={'primary'}
          component="label">
          <Badge badgeContent={media.length} color="secondary">
            <CollectionsIcon />
          </Badge>
        </IconButton>
      )}
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        onClose={() => {
          setOpen(false)
        }}>
        <DialogTitle>Media Gallery</DialogTitle>
        <DialogContent>
          <MediaGalleryCached
            media={media}
            parentId={promptId}
            isMobileDevice
            inspectionId={inspectionId}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false)
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
